module.exports = __webpack_public_path__ + "img/consultation_part6.5f93f457.png";